import { Avatar, Tooltip } from '@mui/material'
import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { EntityType } from '@portal/pkg-api/gen/navigator'
import { IconName } from '@fortawesome/fontawesome-common-types'

export interface IEntityTypeAvatarProps {
  entityType?: EntityType
  opacity?: number
  onClick?: (event: any) => void
  size?: number
  decorative?: boolean
}

class EntityTypeAvatar extends React.Component<IEntityTypeAvatarProps> {
  static defaultProps: Partial<IEntityTypeAvatarProps> = {
    opacity: 1,
    size: 40,
  }

  render() {
    const { entityType, size, size: height, size: width, opacity, decorative } = this.props
    if (!entityType) {
      return null
    }
    return (
      <Tooltip title={entityType.name}>
        <Avatar
          onClick={this.handleClick}
          aria-label={decorative ? undefined : 'recipe'}
          aria-hidden={decorative ? true : undefined}
          style={{
            backgroundColor: entityType.effectiveColor,
            height,
            width,
            opacity,
          }}
        >
          {entityType.iconUrl ? (
            <FontAwesomeIcon
              icon={entityType.iconUrl as IconName}
              style={{
                fontSize: size ? `${size / 40}em` : '1em',
                color: '#fff',
              }}
            />
          ) : (
            <span style={{ color: '#fff' }}>{entityType.name.charAt(0).toUpperCase()}</span>
          )}
        </Avatar>
      </Tooltip>
    )
  }

  handleClick = (event: any) => {
    const { onClick } = this.props
    if (onClick) {
      onClick(event)
    }
  }
}

export default EntityTypeAvatar
